import React, { useEffect, useState } from 'react';
import ChannelListing from './ChannelListing';
import { columnTypes } from 'src/components/UI/atoms/ATMTable/ATMTable';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import {
    setItems,
    setPage,
    setRowsPerPage,
    setSearchValue,
    setIsTableLoading,
    setTotalItems,
} from 'src/redux/slices/ChannelSlice';
import { MdDeleteOutline } from "react-icons/md";
import { RxPencil1 } from "react-icons/rx";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import ATMMenu from 'src/components/UI/atoms/ATMMenu/ATMMenu';
import AddChannelFormWrapper from '../Add/AddChannelFormWrapper';
import EditChannelFormWrapper from '../Edit/EditChannelFormWrapper';
import { useGetAllChannelWithPaginationQuery, useDeleteChannelMutation } from 'src/services/ChannelServices';
import { showToast } from 'src/utils/showToaster';
import { UserModuleActionTypes, UserModuleNameTypes } from "src/models/userAccess/UserAccess.model";
import { isCheckColumnPermission } from 'src/helpers/userAccessFun';
type Props = {};

const ChannelListingWrapper = (props: Props) => {
    const dispatch = useDispatch();
    const { items, totalItems, page, rowsPerPage, searchValue, isTableLoading, } =
        useSelector((state: RootState) => state.channel);

    const [isOpenAddFrom, setIsOpenAddForm] = useState(false);
    const [isOpenEditFrom, setIsOpenEditForm] = useState(false);

    const [channelId, setChannelId] = useState("");
    const [deleteChannel] = useDeleteChannelMutation();

    const { isLoading, isFetching, data } = useGetAllChannelWithPaginationQuery({
        "limit": rowsPerPage,
        "searchValue": "",
        "params": [
            "channelName",
        ],
        "page": 0,
        "filterBy": [],
        "dateFilter": {},
        "orderBy": "createdAt",
        "orderByValue": -1,
        "isPaginationRequired": true
    });

    useEffect(() => {
        if (isLoading || isFetching) {
            dispatch(setIsTableLoading(true));
        } else {
            dispatch(setItems(data?.data || []));
            dispatch(setTotalItems(data?.totalItem || 0));
            dispatch(setIsTableLoading(false));
        }
    }, [isLoading, isFetching, data, dispatch]);


    const columns: columnTypes[] = [
        {
            field: 'channelName', headerName: 'Channel Name', flex: 'flex-[1_1_0%]',
            renderCell: (row: any) => <span> {row?.channelName}</span>,
        },
        {
            noAuthRequired: true,
            field: "action",
            headerName: "Action",
            flex: "flex-[1_1_0%]",
            renderCell: (row: any) => {
                const options = getActionOptions(row);
                return <ATMMenu options={options} orientation="vertical" />;
            },
        },
    ];

    const getActionOptions = (row: any) => {
        return [
            {
                label: (
                    <div className="flex gap-2 items-center text-secondary-main">
                        <RxPencil1 className="text-lg" /> Edit
                    </div>
                ),
                onClick: () => {
                    setIsOpenEditForm(true);
                    setChannelId(row?._id)
                },
                actionName: UserModuleActionTypes.EDIT,
                moduleName: UserModuleNameTypes.CHANNEL
            },
            {
                label: (
                    <div className="flex gap-2 items-center text-red-600 font-semibold">
                        <MdDeleteOutline className="text-lg" /> Delete
                    </div>
                ),
                onClick: () => {
                    showConfirmationDialog({
                        title: "Heads Up",
                        text: "Are you sure want to Delete this Channel ?",
                        icon: "question",
                        showCancelButton: true,
                        next: (result) => {
                            if (result.isConfirmed) {
                                deleteChannel(row?._id).then((res: any) => {
                                    if (res?.error) {
                                        showToast("error", res?.error?.data?.message);
                                    } else {
                                        if (res?.data?.status) {
                                            showToast("success", res?.data?.message);
                                        } else {
                                            showToast("error", res?.data?.message);
                                        }
                                    }
                                });
                            }
                        },
                    });
                },
                actionName: UserModuleActionTypes.DELETE,
        moduleName: UserModuleNameTypes.CHANNEL
            },
        ];
    };
    return (
        <div>
            <ChannelListing
                columns={isCheckColumnPermission({
          moduleName: UserModuleNameTypes.CHANNEL,
          actionName: UserModuleActionTypes.LIST,
          columns: columns
        })}
                rows={items}
                paginationProps={{
                    isTableLoading,
                    totalItems,
                    page,
                    rowsPerPage,
                    searchValue,
                    setPage: (newPage) => dispatch(setPage(newPage)),
                    setRowsPerPage: (newRowsPerPage) => dispatch(setRowsPerPage(newRowsPerPage)),
                    setSearchValue: (newValue) => dispatch(setSearchValue(newValue)),
                }}
                onAddNew={() => setIsOpenAddForm(true)}
            />
            {isOpenAddFrom ? (
                <AddChannelFormWrapper onClose={() => setIsOpenAddForm(false)} />
            ) : null}
            {isOpenEditFrom ? (
                <EditChannelFormWrapper
                    onClose={() => setIsOpenEditForm(false)}
                    channelId={channelId}
                />
            ) : null}
        </div>
    );
};

export default ChannelListingWrapper;